import React, { useState, useEffect } from "react";
import {
  Card,
  Button,
  Table,
  Row,
  Col,
  Spinner,
  Form,
  Accordion,
} from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, HEADERS } from "../../utils/constant";
import ServiceRequestModal from "../../components/Modals/ServiceRequestModel";
import ReactPaginate from "react-paginate";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
import NoData from "../../components/NoData";
import Loader from "../../components/Loader";
import ExportModal from "../../components/Modals/ExportsModel/main";
import { useCommonContext } from "../../utils/context";
import ServiceRequests from "../../components/Modals/HisstoryModals/ServiceRequests";
import { FaEdit, FaFileExport, FaPlus } from "react-icons/fa";
import CommonButton from "../../components/CommonButton";
import StatusBadge from "../../components/StatusBadge";
import Pagination from "../../components/Pagination";
import { useTypeConfig } from "../../utils/useTypeConfig";

const ServiceRequestList = () => {
  const [loading, setLoading] = useState(false);
  const [requests, setRequests] = useState([]);
  const [showServiceRequestModal, setShowServiceRequestModal] = useState(false);
  const [editRequestData, setEditRequestData] = useState(null);
  const [userRole, setUserRole] = useState("");
  const [isStatusUpdate, setIsStatusUpdate] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [searchLeadText, setSearchLeadText] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [exportLoading, setExportLoading] = useState(false);
  const { toggled } = useCommonContext();
  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const userPermissions = localStorage.getItem("user_permissions");
  const [selectedRequest, setSelectedRequest] = useState(null);
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = requests.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(requests.length / itemsPerPage);
  const [showViewModal, setShowViewModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const { labels, hiddenFields } = useTypeConfig();
  useEffect(() => {
    const role = localStorage.getItem("role");
    setUserRole(role || "");
  }, [searchLeadText]);

  useEffect(() => {
    fetchServiceRequests(currentPage);
  }, [currentPage, itemsPerPage, selectedStatus, searchText]);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedStatus, searchText]);

  const fetchServiceRequests = async (page = 1) => {
    setLoading(true);
    try {
      const params = {};

      const response = await axios.get(`${BASE_URL}/api/service-requests`, {
        headers: HEADERS,
        params: {
          page: page,
          page_size: itemsPerPage,
          status: selectedStatus || "",
          search: searchText || "",
        },
      });
      if (response.data) {
        let requests = response?.data?.results || [];
        setRequests(requests);
        setTotalPages(response.data.total_pages);

        setCurrentPage(page);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setCurrentPage(1);
        fetchServiceRequests(1);
      } else {
      }
    } finally {
      setLoading(false);
    }
  };

  const openEditModal = (request) => {
    setEditRequestData(request);
    setIsStatusUpdate(false);
    setShowServiceRequestModal(true);
  };

  const openAddModal = () => {
    setEditRequestData(null);
    setIsStatusUpdate(false);
    setShowServiceRequestModal(true);
  };

  const handleCloseServiceRequestModal = () => {
    setShowServiceRequestModal(false);
    setEditRequestData(null);
    fetchServiceRequests();
  };

  const handleStatusUpdate = (request) => {
    setEditRequestData(request);
    setIsStatusUpdate(true);
    setShowServiceRequestModal(true);
  };

  const handlePageClick = (selectedPage) => {
    const newPage = selectedPage.selected + 1;
    setCurrentPage(newPage);
    fetchServiceRequests(newPage);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setItemOffset(0);
    fetchServiceRequests(1);
  };

  const isAddressEmpty = (address) => {
    return (
      !address?.primary_address &&
      !address?.city &&
      !address?.state &&
      !address?.zipcode &&
      !address?.country
    );
  };

  const handleViewRequest = (request) => {
    setSelectedRequest(request);
    setShowViewModal(true);
  };

  return (
    <div className="container-fluid ">
      <div className="mt-3 d-flex  container-header flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
        <h4 className="mb-md-0">Material Requests</h4>
        <div className="d-none d-md-flex align-items-center gap-2">
          <Form.Control
            type="text"
            placeholder="Search Here..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="uniform-input search-text"
          />

          <Form.Select
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            className="uniform-input"
          >
            <option value="">All Status</option>
            <option value="Submitted">Submitted</option>
            <option value="Approved">Approved</option>
            <option value="Dispatched">Dispatched</option>
          </Form.Select>

          {userPermissions.includes("servicerequest_add_servicerequest") && (
            <CommonButton className="uniform-button" onClick={openAddModal}>
              <FaPlus style={{ marginRight: "6px" }} /> Add
            </CommonButton>
          )}
          {userPermissions.includes("servicerequest_export") && (
            <CommonButton
              className="uniform-button"
              onClick={() => setShowExportModal(true)}
              disabled={currentItems.length === 0}
            >
              <FaFileExport style={{ marginRight: "6px" }} /> Export
            </CommonButton>
          )}
        </div>
        <div className="d-md-none w-100">
          <Accordion flush>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Filters & Actions</Accordion.Header>
              <Accordion.Body>
                <div className="mb-3">
                  <Form.Select
                    value={selectedStatus}
                    onChange={(e) => setSelectedStatus(e.target.value)}
                    className="uniform-input"
                  >
                    <option value="">All Status</option>
                    <option value="Submitted">Submitted</option>
                    <option value="Approved">Approved</option>
                    <option value="Dispatched">Dispatched</option>
                  </Form.Select>
                </div>
                <div className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Search Here..."
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    className="uniform-input search-text"
                  />
                </div>
                <div className="d-flex flex-wrap gap-2 justify-content-start">
                  {userPermissions.includes(
                    "servicerequest_add_servicerequest",
                  ) && (
                    <CommonButton
                      className="uniform-button d-flex align-items-center"
                      onClick={openAddModal}
                      style={{ minWidth: "120px" }}
                    >
                      <FaPlus style={{ marginRight: "6px" }} /> Add
                    </CommonButton>
                  )}
                  {userPermissions.includes("servicerequest_export") && (
                    <CommonButton
                      className="uniform-button d-flex align-items-center"
                      onClick={() => setShowExportModal(true)}
                      disabled={currentItems.length === 0}
                      style={{ minWidth: "120px" }}
                    >
                      <FaFileExport style={{ marginRight: "6px" }} /> Export
                    </CommonButton>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>

      <div
        className={`table-responsive ${requests.length === 0 ? "" : "tabell"} `}
      >
        {loading ? (
          <Loader />
        ) : (
          <>
            {requests.length > 0 ? (
              <table className="table   tstart">
                <thead className="thead">
                  <tr style={{ whiteSpace: "nowrap" }}>
                    <th style={{ width: "350px" }}>Ticket Id/Task Name</th>
                    <th style={{ width: "300px" }}>{labels.customerName}</th>
                    <th style={{ width: "300px" }}>{labels.subCustomerName}</th>
                    <th style={{ width: "200px" }}>Technician Name</th>
                    <th style={{ width: "300px" }}>Address</th>
                    <th style={{ width: "150px" }}>Region</th>
                    <th style={{ width: "150px" }}>Phone No.</th>
                    <th style={{ width: "250px" }}>Materials Required</th>
                    <th style={{ width: "150px" }}>Status</th>
                    <th style={{ width: "150px" }}>Created At</th>
                    <th style={{ width: "150px" }}>Courier CNO.</th>
                    <th style={{ width: "150px" }}>Dockt No</th>
                    <th style={{ width: "300px" }}>Hub Address</th>
                    <th style={{ width: "200px" }}>Dispatched Location</th>
                    <th style={{ width: "250px" }}>Remark</th>
                    <th style={{ width: "250px" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((request, index) => (
                    <tr
                      key={request.id}
                      className="tbody"
                      onClick={() => handleViewRequest(request)}
                    >
                      <td title={request?.ticket?.taskName || "NA"}>
                        <div className="d-flex align-items-center ">
                          <span className="badge bg-primary text-white me-2">
                            {request?.ticket?.id}
                          </span>
                          <div
                            title={request?.ticket?.taskName || "—"}
                            className="tdsubject"
                          >
                            {request?.ticket?.taskName || "—"}
                          </div>
                        </div>
                      </td>

                      <td>
                        <div
                          title={
                            request?.ticket?.customerDetails?.customer_name ||
                            request?.customerDetails?.customer_name ||
                            "—"
                          }
                          className="tdsubject"
                        >
                          {request?.ticket?.customerDetails?.customer_name ||
                            request?.customerDetails?.customer_name ||
                            "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          className="tdsubject"
                          title={
                            request?.ticket?.subCustomerDetails
                              ?.customer_name ||
                            request?.subCustomerDetails?.customer_name ||
                            "—"
                          }
                        >
                          {request?.ticket?.subCustomerDetails?.customer_name ||
                            request?.subCustomerDetails?.customer_name ||
                            "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          className="tdsubject"
                          title={
                            request?.ticket?.assignTo
                              ? `${request?.ticket?.assignTo?.first_name || ""} ${request?.ticket?.assignTo?.last_name || ""}`.trim() ||
                                "—"
                              : "—"
                          }
                        >
                          {request?.ticket?.assignTo
                            ? `${request?.ticket?.assignTo?.first_name || ""} ${request?.ticket?.assignTo?.last_name || ""}`.trim() ||
                              "—"
                            : "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          className="tdsubject"
                          title={
                            request?.ticket?.ticket_address ||
                            request?.subCustomerDetails?.address ||
                            request?.customerDetails?.address ||
                            "—"
                          }
                        >
                          {request?.ticket?.ticket_address ||
                            request?.subCustomerDetails?.address ||
                            request?.customerDetails?.address ||
                            "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          className="tdsubject"
                          title={
                            request?.ticket?.region ||
                            request?.subCustomerDetails?.region ||
                            request?.customerDetails?.region ||
                            "—"
                          }
                        >
                          {request?.ticket?.region ||
                            request?.subCustomerDetails?.region ||
                            request?.customerDetails?.region ||
                            "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          className="tdsubject"
                          title={
                            request?.ticket?.phone_number ||
                            request?.subCustomerDetails?.phone_number ||
                            request?.customerDetails?.phone_number ||
                            "—"
                          }
                        >
                          {request?.ticket?.phone_number ||
                            request?.subCustomerDetails?.phone_number ||
                            request?.customerDetails?.phone_number ||
                            "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={
                            Array.isArray(request.material_required) &&
                            request.material_required.length > 0
                              ? request.material_required
                                  .map((material) =>
                                    material.quantity
                                      ? `${material.name || "NA"} (${
                                          material.quantity
                                        })`
                                      : material.name || "NA",
                                  )
                                  .join(", ")
                              : "No materials"
                          }
                          className="tdsubject"
                        >
                          {Array.isArray(request.material_required) &&
                          request.material_required.length > 0
                            ? request.material_required
                                .map((material) =>
                                  material.quantity
                                    ? `${material.name || "NA"} (${
                                        material.quantity
                                      })`
                                    : material.name || "NA",
                                )
                                .join(", ")
                            : "No materials"}
                        </div>
                      </td>

                      <td>
                        <span
                          style={{
                            backgroundColor:
                              request.status === "Approved"
                                ? "#28a712"
                                : request.status === "Rejected"
                                  ? "#ffc107"
                                  : request.status === "Dispatched"
                                    ? "#ffc107"
                                    : request.status === "Submitted"
                                      ? "#6c757d"
                                      : "#343a40",
                            color: "white",
                            padding: "5px 10px",
                            borderRadius: "5px",
                            fontWeight: "bold",
                          }}
                        >
                          {request.status || "—"}
                        </span>
                      </td>
                      <td>
                        <div
                          title={request?.created_at || "—"}
                          className="tdsubject"
                        >
                          {request?.created_at || "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={request?.courier_contact_number || "—"}
                          className="tdsubject"
                        >
                          {request?.courier_contact_number || "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={request?.dockt_no || "—"}
                          className="tdsubject"
                        >
                          {request?.dockt_no || "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={request?.hub_address || "—"}
                          className="tdsubject"
                        >
                          {request?.hub_address || "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={request?.where_to_dispatched || "—"}
                          className="tdsubject"
                        >
                          {request?.where_to_dispatched || "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={
                            request.status === "Approved"
                              ? request.approved_remark
                              : request.dispatched_remark || "—"
                          }
                          className="tdsubject"
                        >
                          {request.status === "Approved"
                            ? request.approved_remark
                            : request.dispatched_remark || "—"}
                        </div>
                      </td>

                      <td>
                        {userPermissions.includes(
                          "servicerequest_change_servicerequest",
                        ) &&
                          request.status === "Submitted" && (
                            <Button
                              variant="warning"
                              className="me-2"
                              onClick={(e) => {
                                e.stopPropagation();
                                openEditModal(request);
                              }}
                            >
                              Edit
                            </Button>
                          )}
                        {userPermissions.includes(
                          "servicerequest_update_status",
                        ) &&
                          request.status !== "Dispatched" && (
                            <Button
                              variant="success"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleStatusUpdate(request);
                              }}
                              style={{ width: "150px" }}
                            >
                              Update Status
                            </Button>
                          )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <NoData message="No Data Found" height="400px" />
            )}
          </>
        )}
      </div>
      {requests.length > 0 && (
        <Pagination
          // currentPage={currentPage}
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          handlePageClick={handlePageClick}
          handleItemsPerPageChange={handleItemsPerPageChange}
        />
      )}

      <ExportModal
        show={showExportModal}
        handleClose={() => setShowExportModal(false)}
        title="requests"
      />

      {showServiceRequestModal && (
        <ServiceRequestModal
          show={showServiceRequestModal}
          handleClose={handleCloseServiceRequestModal}
          fetchServiceRequests={() => fetchServiceRequests(currentPage)}
          serviceExpenseData={editRequestData}
          isStatusUpdate={isStatusUpdate}
        />
      )}

      <ServiceRequests
        show={showViewModal}
        handleClose={() => setShowViewModal(false)}
        servicerequestId={selectedRequest?.id}
        servicerequest={selectedRequest}
      />
    </div>
  );
};

export default ServiceRequestList;
